module.exports = __webpack_public_path__ + "static/media/evacuation-bg2.b3cfec07.png";